import { BookingTypeEnum } from '../redux/booking/bookingSlice';

export enum DayOfWeekEnum {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
}

export interface DaysOfWeek {
  'common.days.monday': boolean;
  'common.days.tuesday': boolean;
  'common.days.wednesday': boolean;
  'common.days.thursday': boolean;
  'common.days.friday': boolean;
  'common.days.saturday': boolean;
  'common.days.sunday': boolean;
}

export interface TimeRange {
  start: string;
  end: string;
}

export interface DaysOfWeekSchedule {
  'common.days.monday': TimeRange;
  'common.days.tuesday': TimeRange;
  'common.days.wednesday': TimeRange;
  'common.days.thursday': TimeRange;
  'common.days.friday': TimeRange;
  'common.days.saturday': TimeRange;
  'common.days.sunday': TimeRange;
}

export enum TokenTypeEnum {
  GOOGLE_CALENDER = 'GOOGLE_CALENDER',
  MICROSOFT_CALENDAR = 'MICROSOFT_CALENDAR',
  ZOOM = 'ZOOM',
}

export enum PaymentGatewayEnum {
  STRIPE = 'STRIPE',
}

export const sessionTypes = [
  {
    value: BookingTypeEnum.ONLINE,
    label: 'bookings.online',
  },
  {
    value: BookingTypeEnum.IN_PERSON,
    label: 'bookings.inPerson',
  },
];

export const calculateTimeDuration = (startTime: number, endTime: number) => {
  const timeDurationinMin = endTime - startTime;
  const hours = Math.floor(timeDurationinMin / 60);
  const minutes = timeDurationinMin % 60;
  if (hours === 0) {
    return `${minutes}min`;
  }
  if (minutes === 0) {
    return `${hours}h`;
  }
  return `${hours}h ${minutes}min`;
};
